import {Validator} from '@/type/validation/result';

import {必須入力, 日付書式} from '@/type/validation/validator';

export const 出力条件バリデータマップ一覧: Validator[] = [
  {
    name: '出力対象開始日',
    constraints: [
      {method: 必須入力, message: '開始日を入力してください'},
      {method: 日付書式, message: '開始日の書式を正しく入力してください'},
    ],
  },
  {
    name: '出力対象終了日',
    constraints: [
      {method: 必須入力, message: '終了日を入力してください'},
      {method: 日付書式, message: '終了日の書式を正しく入力してください'},
    ],
  },
];
